import {Component, attr} from "../Component";
import {element} from "../CustomElement";
import {Page} from "../flipp-page/Page";

interface IExpiredContentPage {
	h1: string;
	body: string;
}

@element("flipp-expired-content-page")
export class ExpiredContentPage extends Component<IExpiredContentPage, {}> {
	@attr h1: string;
	@attr body: string;

	render() {
		return (
			<Page show="flyers">
				<h1>{this.h1}</h1>
				<div>{this.body}</div>
			</Page>
		);
	}
}
